/** Contact List Types */

export interface ContactListDto {
  id: string;
  organizationId: string;
  title: string;
  type?: 'CSV' | 'OUTREACH' | 'HUBSPOT' | 'SALESFORCE' | 'SESSIONS';
  nonce?: string;
  isFolder?: boolean | undefined;
  sequenceId?: number;
  createdAt?: string;
  updatedAt?: string;
  contactsCount?: number;
  warningsCount?: number;
}

export interface CreateContactListDto {
  organizationId: string;
  title: string;
  type: 'CSV';
  nonce: 'CSV';
}

/** Contact Types */

export interface ContactInfoDto {
  id: string;
  contactListId: string;
  name: string;
  phone: string;
  accountName?: string;
  jobTitle?: string;
  email?: string;
  notes?: string;
  notesAgent?: string;
  notesSDR?: string;
  crmId?: string;
  flagged?: boolean;
  errorMessages?: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface UpdateContactDto {
  id: string;
  name?: string;
  phone?: string;
  accountName?: string;
  jobTitle?: string;
  email?: string;
  notes?: string;
  notesAgent?: string;
  notesSDR?: string;
  crmId?: string;
  flagged?: boolean;
}

/** API Response Types */

export interface ApiError {
  message: string;
  raw?: string;
}

export type ApiResponse<T> =
  | { success: true; data: T; totalPages?: number; totalCount?: number; pageNumber?: number }
  | { success: false; error: ApiError };

/** UI Types */

export type ListSource = 'csv' | 'sessions' | 'outreach' | 'hubspot' | 'salesforce';
export type ContactStatus = 'warning' | 'ok' | 'neutral';
export type ContactsTab = 'csv' | 'sessions'| 'outreach' | 'hubspot' | 'salesforce';

export const enum LoadingState {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

export interface FiltersState {
  no_answer: boolean;
  cut_off: boolean;
  transfer_error: boolean;
  voicemail: boolean;
  fuego_lead: boolean;
}

export const DEFAULT_FILTERS: FiltersState = {
  no_answer: true,
  cut_off: true,
  transfer_error: true,
  voicemail: true,
  fuego_lead: true,
};

/** Helper Functions */

export function statusFromDto (c: ContactInfoDto): ContactStatus {
  const hasWarnings = Array.isArray(c.errorMessages) && c.errorMessages.length > 0;
  return hasWarnings ? 'warning' : 'ok';
}

export function tabToSource (tab: ContactsTab): ListSource {
  if (tab === 'csv') {
    return 'csv';
  }
  if (tab === 'hubspot') {
    return 'hubspot';
  }
  if (tab === 'salesforce') {
    return 'salesforce';
  }
  return 'outreach';
}
